import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import BannerSlider from '../components/BannerSlider'
import LinksDestaque from '../components/LinksDestaque'
import Babypedia from '../components/Babypedia'
import NossosServicos from '../components/NossosServicos'
import NewsletterCTA from '../components/NewsletterCTA'
//import TempoProntoAtendimento from '../components/TempoProntoAtendimento'

export const HomeTemplate = ({ bannersDesktop, bannersMobile, servicos }) => {
  return (
    <>
      {/* <TempoProntoAtendimento /> */}
      <BannerSlider
        bannersDesktop={bannersDesktop}
        bannersMobile={bannersMobile}
      />
      <LinksDestaque />
      <Babypedia title />
      <NossosServicos servicos={servicos} />
      <NewsletterCTA />
    </>
  )
}

const Home = ({ data }) => {
  const { wpPage: page } = data
  const { bannersDesktop } = page.banners
  const { bannersMobile } = page.banners
  const servicos = page.nossosServiOs.paginas

  return (
    <Layout>
      <HomeTemplate
        bannersDesktop={bannersDesktop}
        bannersMobile={bannersMobile}
        servicos={servicos}
      />
    </Layout>
  )
}

export default Home

export const homeQuery = graphql`
  query HomeById($id: String!) {
    wpPage(id: { eq: $id }) {
      title
      content
      nossosServiOs {
        paginas {
          ... on WpPage {
            title
            excerpt
            id
            link
            featuredImage {
              node {
                sourceUrl
                localFile {
                  childImageSharp {
                    fluid(maxWidth: 400, quality: 80) {
                      ...GatsbyImageSharpFluid_withWebp
                    }
                  }
                }
              }
            }
          }
        }
      }
      banners {
        bannersDesktop {
          ... on WpPage_Banners_BannersDesktop_Banner {
            imagem {
              id
              altText
              sourceUrl
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1920, quality: 70) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            youtubeEmbedId
            tipo
            link
          }
        }
        bannersMobile {
          ... on WpPage_Banners_BannersMobile_Banner {
            imagem {
              id
              altText
              sourceUrl
              localFile {
                childImageSharp {
                  fluid(maxWidth: 400, quality: 70) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            youtubeEmbedId
            tipo
            link
          }
        }
      }
    }
  }
`
